/*jshint esversion: 6 */
import store from '@/store/index';

function Template(payload) {
  let route = {
    path: `${payload.step_type?payload.step_type.toLowerCase():''}${payload.content_type.toLowerCase()}`,
    name: `${payload.location}WorkPackage${payload.step_type?payload.step_type:''}${payload.content_type}`,
    component: () => import(
       
       `@/views/Project/WorkPackageRework/WorkPackage${payload.content_type}.view.vue`),
    meta: {
      requiresAuth: true
    },
    props: {
      location: payload.location,
      step_type: payload.step_type,
      backlog: payload.backlog,
      prefix: payload.prefix,
      // on_site: payload.on_site,
    },
    children: [
      {
        path: ':content_id',
        name: `${payload.location}WorkPackage${payload.step_type?payload.step_type:''}${payload.content_type}Details`,
        component: () => import(
           
           `@/views/Project/WorkPackageRework/WorkPackage${payload.content_type}Details.view.vue`),
        meta: {
          requiresAuth: true
        },
        props: {
          location: payload.location,
          step_type: payload.step_type,
          backlog: payload.backlog,
          prefix: payload.prefix,
        },
        beforeEnter: (to, from, next) => {
          if (to.name.includes('Step') && to.params.content_id === 'create' && !store.getters['Project/isEditMode']) {
             //redirect if not in edit mode
             next({
              name: to.matched[to.matched.length-2].name,
              params: to.params,
            });
          } else {
            next();
          }
        },
        children: []
      }
    ]
  };
  if (payload && payload.grand_children) {
    payload.grand_children.forEach((child) => {
      route.children[0].children.push(child);
    });
  }
  return route;
}
export default Template;
